import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const useCheckDeployment = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const checkDeployment = async () => {
            try {

                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}`, {
                    headers: { "Cache-Control": "no-cache" },
                });
                const deploymentTime = response.headers["x-deployment-timestamp"];
                const forceLogout = response.headers["x-force-logout"] === "true";
                const lastKnownDeploy = localStorage.getItem("lastDeploymentTime");

                if (forceLogout) {
                    console.warn("⚠️ Force logout triggered. Clearing storage...");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate("/login");
                    return;
                }

                if (deploymentTime && lastKnownDeploy && deploymentTime !== lastKnownDeploy) {
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate("/login");
                }

                localStorage.setItem("lastDeploymentTime", deploymentTime);
            } catch (error) {
                console.error("Error checking deployment:", error);
                if (error.response) {
                    console.error("Server Response:", error.response);
                    console.error("Headers from Server:", error.response.headers);
                }
            }
        };

        checkDeployment();
    }, [navigate]);
};

export default useCheckDeployment
